import { BuySellClient } from "../../../../../../Wrap/Api/Orders/BuySell";
import { OrdersClient } from "../../../../../../Wrap/Api/Orders/Orders";
import { OrderStatus } from "../../../../../../Wrap/Constants/Enums/Domain/OrderStatus";

export class CancelOrderAction {
    public static getBatchInfo(data, callback) {
        const client = new BuySellClient();
        const promise = client.put(data);
        promise.onSuccess((result) => {
            if (callback) {callback(result);}
        });

        promise.onError((err) => {});
    }

    public static cancel(data, callback) {
        const { cancel, batchInfo } = data;
        const _batchInfo = JSON.parse(JSON.stringify(batchInfo));
        _batchInfo.TransId = 0;
        const investments = [];
        _batchInfo.InvestmentList.forEach((ele) => {
            const cancelled = cancel.includes(ele.InstrumentCode);
            if (cancelled) {
                investments.push(ele);
            }
        });
        _batchInfo.BuyOrSell = investments[0].BuyOrSell;
        _batchInfo.InvestmentList = investments;
        const client = new OrdersClient();
        client.put(_batchInfo).onSuccess((result) => {
            callback(result);
        });
    }

    public static submit(data, callback) {
        const client = new OrdersClient();
        client.post(data).onSuccess((result) => {
            callback(result);
        });
    }
}
